import { cx } from '@linaria/atomic';
import { Text } from '../../';
import { Heading } from '../../heading';
import { useModalContext } from '../provider';
import {
  fullscreenModalHeader,
  fullscreenModalHeaderSubtitle,
  fullscreenModalHeaderTitle,
} from './fullscreen-modal-header.styles';

type Props = {
  title?: string;
  subtitle?: string;
  className?: string;
};

export const FullscreenModalHeader = ({ title, subtitle, className, ...rest }: Props) => {
  const { titleId } = useModalContext();
  return (
    <header className={cx(fullscreenModalHeader, className)} {...rest}>
      {!!title && (
        <Heading title={title} id={titleId} className={fullscreenModalHeaderTitle} level={2} textAlign='center'>
          {title}
          {!!subtitle && (
            <Text
              title={subtitle}
              className={fullscreenModalHeaderSubtitle}
              as='span'
              size='medium'
              textAlign='center'
              weight='regular'
            >
              {subtitle}
            </Text>
          )}
        </Heading>
      )}
    </header>
  );
};
